import Colors from "../../../../theme/colors";

const Styles = {
  cardStyle: {
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 15,
    height: "100%",
    position: "relative",
  },
  gridContainerStyle: { padding: 10 },

  divNewEntryForm: {
    padding: "20px 20px 20px 30px",
  },

  divOrganizationStructure: { padding: "20px 30px 20px 20px" },
  typography: {
    color: "#0000FF",
    marginBottom: 25,
    fontSize: 22,
    fontWeight: 500,
  },

  customTextFieldName: {
    width: "100%",
    marginBottom: 10,
  },

  customTextFieldSecondary: {
    width: "85%",
    marginBottom: 10,
  },

  container: {
    marginTop: 8,
  },

  gridPrimary: {
    marginTop: 4,
  },

  buttonStyle: {
    marginTop: 40,
    backgroundColor: Colors.midnightBlue,
    borderRadius: 5,
    width: 150,
    height: 52,
    marginLeft: "20%",
    marginBottom: "20%",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridRowGap: "1.5rem",
    gridColumnGap: "3.75rem",
  },
  name: {
    gridColumn: "1 / 3",
  },
};

export default Styles;
